import { useDispatch, useSelector } from "react-redux";
import { login } from "../Services/AuthServices";
import { useNavigate } from "react-router-dom";
import { OnSignIn, onSignOut, setUserDet } from "../../store/slices/authSlice";
import { jwtDecode } from "jwt-decode"; // Corrected import
import { useEffect, useState } from "react";
import { Button, Toast } from "react-bootstrap";

function useAuth() {
  const state = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState(""); // State to hold toast message
  const [token, setToken] = useState(localStorage.getItem("LogIn_Token"));

  console.log("tokentest", token);

  const signIn = async (email, password) => {
    const response = await login(email, password);
    if (response.Success) {
      dispatch(OnSignIn(response.Body));

      if (response.Body) {
        localStorage.setItem("LogIn_Token", response.Body);
        const decodedToken = jwtDecode(response.Body);

        // Setting token expiration time (e.g., 2 hours) and current time
        const curTime = new Date().getTime();
        const expirationTime = curTime + 2 * 60 * 60 * 1000; // 2 hours

        localStorage.setItem("curTime", curTime.toString());
        localStorage.setItem("tokenExpTime", expirationTime.toString());

        dispatch(setUserDet(decodedToken));
        setToken(response.Body);
        localStorage.setItem("DecodedToken", JSON.stringify(decodedToken));
        return response;
      }
    } else if (response.Error) {
      setToastMessage("Login failed. Please try again.");
      setShowToast(true);
      return response;
    }
  };

  const signOut = () => {
    localStorage.removeItem("tokenExpTime");
    localStorage.removeItem("LogIn_Token");
    localStorage.removeItem("DecodedToken");
    localStorage.removeItem("curTime");
    dispatch(onSignOut());
    setToken(null);
    setToastMessage("You have been signed out successfully.");
    setShowToast(true);

    // Delay navigation to allow toast to appear
    setTimeout(() => {
      navigate("/login");
    }, 500);
  };

  useEffect(() => {
    const checkTokenExpiration = () => {
      const tokenExpTime = parseInt(localStorage.getItem("tokenExpTime"), 10);
      const curTime = parseInt(localStorage.getItem("curTime"), 10);

      if (tokenExpTime && curTime) {
        const now = Date.now();
        if (now >= tokenExpTime) {
          setToastMessage("Session expired. Please log in again.");
          setShowToast(true);
          signOut(); // Automatically sign out if token is expired
        }
      }
    };

    checkTokenExpiration();

    // Set interval to check token expiration every minute
    const intervalId = setInterval(checkTokenExpiration, 1 * 60 * 1000);
    return () => clearInterval(intervalId);
  }, []);

  return {
    token,
    signIn,
    signOut,
    showToastComponent: (
      <Toast
        onClose={() => setShowToast(false)}
        show={showToast}
        delay={3000} // Toast delay set to 3 seconds
        autohide
        style={{ position: "fixed", top: "10px", right: "10px" }}
      >
        <Toast.Header>
          <strong className="me-auto">Notification</strong>
          <small>Just now</small>
        </Toast.Header>
        <Toast.Body>{toastMessage}</Toast.Body>
      </Toast>
    ),
  };
}

export default useAuth;
